import gql from 'graphql-tag'

export const GET_VEHICLE_ODOMETER = gql`
  query VehicleOdometer($filter: GetVehicleOdometerFilter) {
    vehicleOdometer(filter: $filter) {
      isSuccessful
      message
      vehicleOdometer {
        id
        odometer
        odometerEditedOn
        vehicleType {
          type
          category
        }
        licensePlate
        vehicleStatus {
          lastPacket
        }
      }
    }
  }
`

export const UPDATE_VEHICLE_ODOMETER = gql`
  mutation UpdateVehicleOdometer($input: UpdateVehicleOdometerFilter!) {
    updateVehicleOdometer(input: $input) {
      isSuccessful
      message
      updateVehicleOdometer {
        id
      }
    }
  }
`
